import { environment } from '@internal/environment/environment';

const { GA_MEASUREMENT_ID } = environment;

export const getGAClientId = () =>
    new Promise(
        resolve =>
            GA_MEASUREMENT_ID &&
            window.gtag('get', GA_MEASUREMENT_ID, 'client_id', resolve),
    );
